// eslint-disable-next-line import/no-anonymous-default-export
export default (location = [], action) => {
  switch (action.type) {
    case "FETCH_ALL_LOCATION":
      return action.payload;

    case "CREATE_LOCATION":
      return [...location, action.payload];

    case "UPDATE_LOCATION":
      return location.map((item) =>
        item.id === action.payload._id ? action.payload : item,
      );

    case "DELETE_LOCATION":
      return location.filter((item) => item._id !== action.payload);

    default:
      return location;
  }
};
